import { Injectable } from "@angular/core";
import { ApiService } from "../../core/services/api.service";
import { HistoricVarsDTO } from "../../shared/DTO/HistoricVarsDTO";
import { HistoricVar, VarStats } from "../devices/device.model";
import { HOUSE_PROFILE } from "../houses/houses.constants";
import { VarStatsDTO } from "../../shared/DTO/VarStatsDTO";
import { DataDTO } from "../../shared/DTO/DataDTO";
import { SessionStateService } from "../../core/services/session-state.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class EnergyService {
  constructor(
    private apiService: ApiService,
    private sessionStateService: SessionStateService
  ) {}

  isConsumptionClient(): boolean {
    return this.sessionStateService.getHouse()
      ? this.sessionStateService.getHouse().houseProfile ===
          HOUSE_PROFILE.CONSUMPTION
      : false;
  }

  isCommunityConsumption() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.COMMUNITY_CONSUMPTION
    );
  }

  isCommunitySelfConsumption() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.COMMUNITY_SELFCONSUMPTION
    );
  }

  isCommunityProduction() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.COMMUNITY_PRODUCTION
    );
  }

  isCommunity() {
    return (
      this.isCommunityConsumption() ||
      this.isCommunitySelfConsumption() ||
      this.isCommunityProduction()
    );
  }

  isStorageClient(): boolean {
    return this.sessionStateService.getHouse()
      ? this.sessionStateService.getHouse().houseProfile ===
          HOUSE_PROFILE.STORAGE
      : false;
  }

  isAutoConsumption(): boolean {
    return this.sessionStateService.getHouse()
      ? this.sessionStateService.getHouse().houseProfile ===
          HOUSE_PROFILE.SELF_CONSUMPTION
      : false;
  }

  isAutoConsumptionWithBattery(): boolean {
    return this.sessionStateService.getHouse()
      ? this.sessionStateService.getHouse().houseProfile ===
          HOUSE_PROFILE.STORAGE
      : false;
  }

  isMicroGeneration(): boolean {
    return this.sessionStateService.getHouse()
      ? this.sessionStateService.getHouse().houseProfile === "Microgeneration"
      : false;
  }

  getBatteryStatus(id: number) {
    return this.apiService
      .get(`${environment.uiApi.url}/sonnenbatteryapi/` + id + "/api/v1/status")
      .map((battery) => battery.USOC);
  }

  getGasByDay(id: String, day: string, unit: number, resolution: number) {
    return this.apiService.get(
      'https://www.meteroptimizationserver.com/MDCEdp/API.svc/profileDay?query={id:"' +
        id +
        '",day:"' +
        day +
        '",resolution:' +
        resolution +
        ",unit:" +
        unit +
        "}"
    );
  }

  getGasByMonth(id: String, month: number, year: number, unit: number) {
    return this.apiService.get(
      'https://www.meteroptimizationserver.com/MDCEdp/API.svc/profileMonth?query={id:"' +
        id +
        '",month:' +
        month +
        ",year:" +
        year +
        ",unit:" +
        unit +
        "}"
    );
  }

  getGasByYear(id: String, year: number, unit: number) {
    return this.apiService.get(
      'https://www.meteroptimizationserver.com/MDCEdp/API.svc/profileYear?query={id:"' +
        id +
        '",year:' +
        year +
        ",unit:" +
        unit +
        "}"
    );
  }

  getGasTotalByDay(id: String, day: string, unit: number, resolution: number) {
    return this.apiService.get(
      'https://www.meteroptimizationserver.com/MDCEdp/API.svc/totalizerDay?query={id:"' +
        id +
        '",day:"' +
        day +
        '",resolution:' +
        resolution +
        ",unit:" +
        unit +
        "}"
    );
  }

  getGasTotalByMonth(id: String, month: number, year: number, unit: number) {
    return this.apiService.get(
      'https://www.meteroptimizationserver.com/MDCEdp/API.svc/totalizerMonth?query={id:"' +
        id +
        '",month:' +
        month +
        ",year:" +
        year +
        ",unit:" +
        unit +
        "}"
    );
  }

  getGasTotalByYear(id: String, year: number, unit: number) {
    return this.apiService.get(
      'https://www.meteroptimizationserver.com/MDCEdp/API.svc/totalizerYear?query={id:"' +
        id +
        '",year:' +
        year +
        ",unit:" +
        unit +
        "}"
    );
  }

  public getTotals(houseId: string) {
    return this.apiService.get(`/meteringapi/house/${houseId}/energy/totals`);
  }

  public getPredictionGraph(houseId: string) {
    return this.apiService.get(
      `/meteringapi/house/${houseId}/prediction/graph`
    );
  }

  public getPredictionTotal(houseId: string) {
    return this.apiService.get(
      `/meteringapi/house/${houseId}/prediction/total`
    );
  }

  public getPowerMetering(resolution: string, start: string, end: string) {
    return this.apiService.get(
      `/meteringapi/house/${
        this.sessionStateService.getHouse().houseId
      }/power?end=${end}&start=${start}&resolution=${resolution}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy.service.ts